import L10N from "../L10NModule";

import "./Header.css";
import img_logo from "../assets/images/logo.png";

function SetLangAndRefresh(lang: L10N.LangType) {
    L10N.Lang_Set(lang);
    window.location.reload();
}

function Nav_Menu() {
    let currentPage = window.location.pathname;
    return (
        <div className="header-menu">
            <a className={`header-menu_li ${currentPage === "/" ? "active" : ""}`} href="/">{L10N.Static_Get(L10N.StaticConst.home)}</a>
            <a className={`header-menu_li ${currentPage === "/works" ? "active" : ""}`} href="/works">{L10N.Static_Get(L10N.StaticConst.work)}</a>
            <Nav_Lang />
        </div>
    );
}

function Nav_Lang() {
    let lang = L10N.Lang_Current();
    return (
        <div className="header-lang">
            <a
                className={lang === L10N.LangType.ZH_CN ? "active" : ""}
                onClick={() => SetLangAndRefresh(L10N.LangType.ZH_CN)}
            >
                {L10N.Static_Get(L10N.StaticConst.chinese)}
            </a>
            <b> | </b>
            <a className={lang === L10N.LangType.EN ? "active" : ""} onClick={() => SetLangAndRefresh(L10N.LangType.EN)}>
                {L10N.Static_Get(L10N.StaticConst.english)}
            </a>
        </div>
    );
}

export function Com_Header() {
    return (
        <div className="header">
            <div className="header-logo">
                <a href="/"><img src={img_logo} alt="Logo" /></a>
            </div>
            <div className="header-title"><a href="/">{L10N.Static_Get(L10N.StaticConst.title)}</a></div>
            <Nav_Menu />
        </div>
    );
}
